import cn from 'classnames';
import { useCallback, useContext, useLayoutEffect, useMemo } from 'react';

import { Cross } from '@webapp/common/assets/icons';
import { CustomStylesCtx } from '@webapp/common/components/custom-styles';
import { CssUiComponent } from '@webapp/common/components/survey-custom';
import { useClickOutside } from '@webapp/common/hooks/use-click-outside';
import { useLockScroll } from '@webapp/common/hooks/use-lock-scroll';

import css from './modal.css';

export const AgreementModal: FC<{
    onClose?: () => void;
    children?: ReactNode;
}> = ({ children, onClose }) => {
    const { disable, enable } = useLockScroll();
    const handleClose = useCallback(() => {
        enable();
        onClose();
    }, [enable, onClose]);
    const ref = useClickOutside(handleClose);
    const {
        imageSlider: {
            root: { color },
        },
    } = useContext(CustomStylesCtx);
    const style = useMemo(() => ({ stroke: color, color: `${color}` }), [color]);

    useLayoutEffect(() => {
        disable();
        return enable;
    }, [disable, enable]);

    return (
        <div className={cn(CssUiComponent.MODAL, css.modal)}>
            <div className={css.content} ref={ref}>
                {children}
            </div>
            <Cross className={css.close} style={style} onClick={handleClose} />
        </div>
    );
};
